import React, { Component } from 'react'
export class Loading extends Component {
    constructor(props) {
        super(props);
        this.state = {
            text: 'Loading'
        };
    }
    componentDidMount() {
        document.body.setAttribute('style', 'cursor: wait !important')
        let browserCursor = document.getElementById('CursorControl')
        if(browserCursor !== null){
            browserCursor.className = "LoadingCursor"
        }
        const stopper = this.state.text + '...';
        this.interval = window.setInterval(() => {
            this.state.text === stopper
                ? this.setState(() => ({ text: 'Loading' }))
                : this.setState((prevState) => ({ text: prevState.text + '.' }));
        }, 300);
    }
    componentWillUnmount() {
        window.clearInterval(this.interval);
        document.body.style.cursor = 'auto';
        let browserCursor = document.getElementById('CursorControl')
        if(browserCursor !== null){
            browserCursor.className = "DefaultCursor"
        } 
    }
    render() {
        return (<span>
            {this.state.text}
        </span>);
    }
}